import { useState } from "react";
import CustomText from "../atomic/CustomText";
import { ColumnDef, ColumnFiltersState } from "@tanstack/react-table";
import DataTable from "../global/DataTable";
import useQueryParams from "../../services/utils/custom hooks/QueryHelper";

function AssociatedOrganizationAndRolesTable({
  isLoading,
  data,
  tableContainerClass,
  userRoles,
}: {
  isLoading: boolean;
  data: any[];
  tableContainerClass?: string;
  userRoles?: string[];
}): JSX.Element {
  const query = useQueryParams();
  const [columns, setColumns] = useState<ColumnDef<any, unknown>[]>([
    {
      accessorKey: "numbering",
      header: "",
      enableColumnFilter: false,
      cell: ({ cell, row }) => <p>{row.index + 1}</p>,
    },
    {
      accessorKey: "name",
      header: "Name",
      meta: {
        placeholder: "Filter",
      },
    },
    {
      accessorKey: "roles",
      header: "Roles",
      meta: {
        placeholder: "Filter",
      },
    },
  ]);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>(
    columns
      .map((column: any) => ({
        id: column.accessorKey,
        value: query.get(column.accessorKey),
      }))
      .filter((data) => !!data.value)
  );
  const [params, setParams] = useState<string>("");
  return (
    <div className="md:mt-5 xs:px-3 md:px-5 xs:overflow-auto">
      <CustomText
        text={`Associated ${userRoles?.includes("PathLab User") ? "PathLab" : "Organization"} & Roles`}
        fontWeight="font-semibold"
        className="my-5"
      />
      <DataTable
        tableContainerClass={tableContainerClass}
        columns={columns}
        setParams={setParams}
        columnFilters={columnFilters}
        isFetching={isLoading}
        setColumnFilters={setColumnFilters}
        enableClientSideFiltering
        enableClientSideSorting
        data={Array.isArray(data) ? data : []}
      // rowClickable={true}
      />
    </div>
  );
}

export default AssociatedOrganizationAndRolesTable;
